import { useEffect, useState } from 'react';
import { apiFetch } from '../lib/api';

// Der Inhalt wird bei jedem Aufruf live über das Backend von der Quellseite
// geladen (dort bereits bereinigt), damit Änderungen sofort sichtbar sind.
export function ImpressumPage() {
  const [html, setHtml] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    apiFetch<{ html: string }>('/legal/impressum', { skipAuthRefresh: true })
      .then((res) => {
        if (!cancelled) setHtml(res.html);
      })
      .catch(() => {
        if (!cancelled) setError('Das Impressum konnte nicht geladen werden. Bitte versuche es später erneut.');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="stack">
      <h1>Impressum</h1>
      {error && <p className="error-text" role="alert">{error}</p>}
      {!error && html === null && <p className="muted">Wird geladen…</p>}
      {html !== null && <div className="card legal-content" dangerouslySetInnerHTML={{ __html: html }} />}
    </div>
  );
}
